import { appPath } from '../../utils/appPaths.js';

export const DEFAULT_MENU_ROLE = "admin";

export const MENUITEMS = {
  admin: [
    {
      menutitle: "General",
      menucontent: "Users,Artists,Products,Expenses,Invoices,Providers",
      Items: [
        {
          title: "Home",
          icon: "home",
          path: appPath('/dashboard'),
          type: "link",
          bookmark: true,
          active: false,
        },
        {
          title: "Users",
          icon: "user",
          path: appPath('/users/users-list'),
          type: "link",
          bookmark: true,
          active: false,
        },
        {
          title: "Artists",
          icon: "social",
          path: appPath('/artists/artists-list'),
          type: "link",
          bookmark: true,
          active: false,
        },
        {
          title: "Labels",
          icon: "project",
          path: appPath('/labels/labels-list'),
          type: "link",
          bookmark: true,
          active: false,
        },
/*         

        {
          title: "Products",
          icon: "project",
          path: appPath('/products/products-list'),
          type: "link",
          bookmark: true,
          active: false,
          // children: [
          //   {
          //     path: appPath('/products/product-list'),
          //     title: "Products, Assets, Contributors",
          //     type: "link",
          //   },
          // ],
        }, */
        {
          title: "Income",
          icon: "table",
          path: appPath('/income/income-list'),
          type: "link",
          bookmark: true,
          active: false,
        },
        {
          title: "Contributors",
          icon: "ui-kits",
          path: appPath('/contributors'),
          type: "link",
          bookmark: true,
          active: false,
        },

        {
          title: "Exchange",
          icon: "internationalization",
          path: appPath('/exchange'),
          type: "link",
          bookmark: true,
          active: false,
        },
        {
          title: "BudgetTrack",
          icon: "charts",
          path: appPath('/budget-track'),
          type: "link",
          bookmark: true,
          active: false,
        },
        {
          title: "Reporting mode",
          icon: "file",
          path: appPath('/settings/reporting'),
          type: "link",
          bookmark: true,
          active: false,
        },
        {
          title: "Validation",
          icon: "task",
          path: appPath('/validation'),
          type: "link",
          bookmark: true,
          active: false,
        },
        {
          title: "AFR",
          icon: "support-tickets",
          path: appPath('/afr'),
          type: "link",
          bookmark: true,
          active: false,
        },

        // {
        //   title: "Asset",
        //   icon: "social",
        //   path: appPath('/asset/asset-list'),
        //   type: "link",
        //   bookmark: true,
        //   active: false,
        //   // children: [
        //   //   {
        //   //     path: appPath('/artists/artist-list'),
        //   //     title: "Artists",
        //   //     type: "link",
        //   //   },
        //   // ],
        // },
          /*
        {
          title: "Expenses",
          icon: "landing-page",
          type: "sub",
          bookmark: true,
          active: false,
          children: [
            {
              path: appPath('/expenses/red-expenses'),
              title: "InHouse Expenses",
              type: "link",
            },
            {
              path: appPath('/expenses/contributors-expenses'),
              title: "Contributors Expenses",
              type: "link",
            },
          ],
        },
        */
          /*
        {
          title: "Providers",
          icon: "ui-kits",
          type: "sub",
          active: false,
          children: [
            {
              path: appPath('/providers/fuga'),
              title: "Fuga",
              type: "link",
            },
            {
              path: appPath('/providers/youtube-api'),
              title: "YouTube API",
              type: "link",
            },
            {
              path: appPath('/providers/sentric'),
              title: "Sentric",
              type: "link",
            },
          ],
        }

           */
      ],
    },
  ],
  staff: [
    {
      menutitle: "Staff",
      menucontent:
        "Dashboards,Users,Labels,Releases,Transfer,Smart Link,Analitycs",
      Items: [
        {
          title: "Dashboard",
          icon: "home",
          type: "link",
          path: appPath('/dashboard'),
          active: false,
        },
        {
          title: "Users",
          icon: "user",
          path: appPath('/users/user-list'),
          type: "sub",
          bookmark: true,
          active: false,
          children: [
            {
              path: appPath('/users/users-list'),
              type: "link",
              title: "Manage",
            },
            {
              path: appPath('/project/new-project'),
              type: "link",
              title: "Permissions",
            },
          ],
        },
        {
          title: "Releases",
          icon: "project",
          type: "sub",

          active: false,
          children: [
            {
              path: appPath('/releases/catalog'),
              type: "link",
              title: "Catalog",
            },
            {
              path: appPath('/releases/new-catalog'),
              type: "link",
              title: "Build Product",
            },
            {
              path: appPath('/releases/import'),
              type: "link",
              title: "ImportRelease",
            },
          ],
        },
        {
          title: "Transfer",
          icon: "button",
          type: "sub",
          active: false,
          children: [
            {
              path: appPath('/transfer'),
              title: "Create",
              type: "link",
            },
          ],
        },
        {
          title: "Smart Link",
          icon: "button",
          type: "sub",
          active: false,
          children: [
            {
              path: appPath('/geniuslink'),
              title: "Create",
              type: "link",
            },
          ],
        },
        {
          title: "Analitycs",
          icon: "charts",
          path: appPath('/analytics/manage'),
          active: false,
          type: "link",
          children: [
            {
              path: appPath('/charts/apex'),
              type: "link",
              title: "Apex",
            },
            {
              path: appPath('/charts/google'),
              type: "link",
              title: "Google",
            },
            {
              path: appPath('/charts/chartjs'),
              type: "link",
              title: "Chartjs",
            },
          ],
        },
      ],
    },
  ],
};

export const normalizeUserRole = (role) =>
  role && MENUITEMS[role] ? role : DEFAULT_MENU_ROLE;

export const getMenuItemsForRole = (role) =>
  MENUITEMS[normalizeUserRole(role)] || MENUITEMS[DEFAULT_MENU_ROLE] || [];
